/** 监听页面回退 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const listenH5BackToH5 = (callback: () => void, isAutoRemoveListener = true) => {
  if (window.performance && window.performance.navigation.type === 2) {
    callback();
  } else {
    const toExecuteFunc = (event: PageTransitionEvent) => {
      if (event.persisted) {
        callback();
        if (isAutoRemoveListener) {
          window.removeEventListener('pageshow', toExecuteFunc);
        }
      }
    };
    window.addEventListener('pageshow', toExecuteFunc);
    return {
      clearH5BackToH5: () => {
        window.removeEventListener('pageshow', toExecuteFunc);
      },
    };
  }
  return {
    clearH5BackToH5: null,
  };
};

/** 监听APP切换回退 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const listenAppBackToApp = (callback: () => void, isAutoRemoveListener = true) => {
  let hiddenProperty: string;
  if ('hidden' in window.document) {
    hiddenProperty = 'hidden';
  } else if ('webkitHidden' in document) {
    hiddenProperty = 'webkitHidden';
  } else if ('mozHidden' in document) {
    hiddenProperty = 'mozHidden';
  }
  const toExecuteFunc = () => {
    if (document.visibilityState === 'visible' || !document[hiddenProperty as keyof Document]) {
      /** TODO:若重复调用listenAppBackToApp，存在重复监听问题 */
      if (isAutoRemoveListener) {
        document.removeEventListener('visibilitychange', toExecuteFunc);
      }
      callback();
    }
  };
  document.addEventListener('visibilitychange', toExecuteFunc);

  return {
    clearAppBackToApp: () => {
      document.removeEventListener('visibilitychange', toExecuteFunc);
    },
  };
};

/** 监听页面回退通用方法 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const listerBack = (callback: () => void, isAutoRemoveListener = true) => {
  const { clearH5BackToH5 } = listenH5BackToH5(callback, isAutoRemoveListener);
  const { clearAppBackToApp } = listenAppBackToApp(callback, isAutoRemoveListener);
  const clearBackLister = () => {
    if (clearH5BackToH5) {
      clearH5BackToH5();
    }
    if (clearAppBackToApp) {
      clearAppBackToApp();
    }
  };

  return {
    clearBackLister,
  };
};
